import { UNPROCESSABLE_ENTITY } from 'http-status-codes'

import { ErrorBase } from './ErrorBase'

const TRANSLATION_KEY = 'user.signupTeam.msgErrTeamAlreadyExists'
export class TeamExistsError extends ErrorBase {
  name = 'TeamExistsError'

  constructor (message) {
    super(message, TRANSLATION_KEY, UNPROCESSABLE_ENTITY)
  }
}
